import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import listensToClickOutside from 'react-onclickoutside';
import { Link } from 'react-router';
import classnames from 'classnames';
import MenuAbout from './MenuAbout';
import MenuApply from './MenuApply';
import MenuFestival from './MenuFestival';
import MenuBFW from './MenuBFW';
import MenuCategories from './MenuCategories';
import MenuDirectory from './MenuDirectory';


function Logo(props) {
  return (
    <Link to="/" className="logo">WorldWideWomen</Link>
  )
}


function mapStateToProps(state) {
  return {
    items: state.baseState.categories,
    browser: state.browser
  }
}

@connect(mapStateToProps, {})
@listensToClickOutside
class MenuMain extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      categoriesOpen: false,
      aboutOpen: false,
      festivalOpen: false,
      applyOpen: false,
      bfwOpen: false
    }
  }

  closeMenu = (e) => {
    this.setState({ isOpen: false });
  }

  /**** BEGIN: Event handling for logo clicks ****/
  handleClickOutside = (event) => {
    this.setState({ isOpen: false });
  };

  toggle = (event) => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  open = (event) => {
    this.setState({ isOpen: true });
  }

  close = (event) => {
    this.setState({ isOpen: false });
  }
  /**** END: Event handling for logo clicks ****/

  // -----------------------------------------------

  /**** BEGIN: Event handling for Discover Resources clicks ****/
  toggleCategories = (event) => {
    this.setState({ categoriesOpen: !this.state.categoriesOpen });
    this.setState({ aboutOpen: false });
    this.setState({ festivalOpen: false });
    this.setState({ applyOpen: false });
    this.setState({ bfwOpen: false });

    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  openCategories = (event) => {
    this.setState({ categoriesOpen: true });
  }
  /**** END: Event handling for Discover Resources clicks ****/

  // -----------------------------------------------

  /**** BEGIN: Event handling for About Us clicks ****/
  toggleAbout = (event) => {
    this.setState({ aboutOpen: !this.state.aboutOpen });
    this.setState({ categoriesOpen: false });
    this.setState({ festivalOpen: false });
    this.setState({ applyOpen: false });
    this.setState({ bfwOpen: false });

    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  openAbout = (event) => {
    this.setState({ aboutOpen: true });
  }
  /**** END: Event handling for About Us clicks ****/

  // -----------------------------------------------

  /**** BEGIN: Event handling for Apply to List clicks ****/
  toggleApply = (event) => {
    this.setState({ applyOpen: !this.state.applyOpen });
    this.setState({ categoriesOpen: false });
    this.setState({ aboutOpen: false });
    this.setState({ festivalOpen: false });
    this.setState({ bfwOpen: false });

    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  openApply = (event) => {
    this.setState({ applyOpen: true });
  }
  /**** END: Event handling for About Us clicks ****/

  /**** BEGIN: Event handling for Apply to List clicks ****/
  toggleBFW = (event) => {
    this.setState({ bfwOpen: !this.state.bfwOpen });
    this.setState({ categoriesOpen: false });
    this.setState({ aboutOpen: false });
    this.setState({ festivalOpen: false });
    this.setState({ applyOpen: false });

    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  openApply = (event) => {
    this.setState({ applyOpen: true });
  }
  /**** END: Event handling for About Us clicks ****/

  /**** BEGIN: Event handling for Girls Festival clicks ****/
  toggleFestival = (event) => {
    this.setState({ festivalOpen: !this.state.festivalOpen });
    this.setState({ categoriesOpen: false });
    this.setState({ aboutOpen: false });
    this.setState({ applyOpen: false });
    this.setState({ bfwOpen: false });

    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  openFestival = (event) => {
    this.setState({ festivalOpen: true });
  }
  /**** END: Event handling for About Us clicks ****/


  topMenuObjArray = [
    {
      name: 'Discover Resources',
      url: '',
      slug: 'categories',
      hover: true,
      isExternalUrl: false
    },
    // {
    //   name: 'BuyFromWomen',
    //   url: '',
    //   slug: 'buy-from-women-owned-businesses',
    //   hover: true,
    //   isExternalUrl: false
    // },
    // {
    //   name: "Girls' Festival",
    //   url: 'http://worldwidewomengirlsfestival.org',
    //   slug: 'girls-festival',
    //   hover: false,
    //   isExternalUrl: true
    // },
    {
      name: 'Apply to List',
      url: '/apply-to-list-lp',
      slug: 'apply-to-list',
      hover: false,
      isExternalUrl: false
    },
    {
      name: 'About Us',
      url: '',
      slug: 'about-us',
      hover: true,
      isExternalUrl: false
    },
  ];

  render() {
    const { items, browser } = this.props

    let menu = ''
    let menuClasses = classnames({
      'menuToggle': true,
      'open': this.state.isOpen,
      'closed': !this.state.isOpen,
    })

    let iconClasses = classnames({
      'fa': true,
      'fa-chevron-up': this.state.isOpen,
      'fa-chevron-down': !this.state.isOpen,
      'fa-2x': true
    })


    let menuCategoryClasses = classnames({
      'menuCategoryToggle': true,
      'open': this.state.categoriesOpen,
      'closed': !this.state.categoriesOpen,
    })

    let menuAboutClasses = classnames({
      'menuAboutToggle': true,
      'open': this.state.aboutOpen,
      'closed': !this.state.aboutOpen,
    })

    let menuBFWClasses = classnames({
      'menuBFWToggle': true,
      'open': this.state.bfwOpen,
      'closed': !this.state.bfwOpen,
    })

    let menuApplyClasses = classnames({
      'menuApplyToggle': true,
      'open': this.state.applyOpen,
      'closed': !this.state.applyOpen,
    })

    let menuFestivalClasses = classnames({
      'menuFestivalToggle': true,
      'open': this.state.festivalOpen,
      'closed': !this.state.festivalOpen,
    })

    let iconCategoryClasses = '';
    let iconAboutClasses = '';
    let iconApplyClasses = '';
    let iconFestivalClasses = '';
    let iconBFWClasses = '';

    if (!this.props.browser.greaterThan.desktop) {
      iconCategoryClasses = classnames({
        'fa': true,
        'fa-chevron-up': this.state.categoriesOpen,
        'fa-chevron-down': !this.state.categoriesOpen,
        'fa-2x': true
      })

      iconAboutClasses = classnames({
        'fa': true,
        'fa-chevron-up': this.state.aboutOpen,
        'fa-chevron-down': !this.state.aboutOpen,
        'fa-2x': true
      })

      iconApplyClasses = classnames({
        'fa': true,
        'fa-chevron-up': this.state.applyOpen,
        'fa-chevron-down': !this.state.applyOpen,
        'fa-2x': true
      })

      iconBFWClasses = classnames({
        'fa': true,
        'fa-chevron-up': this.state.applyOpen,
        'fa-chevron-down': !this.state.applyOpen,
        'fa-2x': true
      })

      iconFestivalClasses = classnames({
        'fa': true,
        'fa-chevron-up': this.state.festivalOpen,
        'fa-chevron-down': !this.state.festivalOpen,
        'fa-2x': true
      })
    } else if (this.props.browser.greaterThan.desktop) { // we are in desktop now
      iconCategoryClasses = classnames({
        'fa': true,
        'fa-chevron-up': false,
        'fa-chevron-down': true,
        'fa-2x': true
      })

      iconAboutClasses = classnames({
        'fa': true,
        'fa-chevron-up': false,
        'fa-chevron-down': true,
        'fa-2x': true
      })

      iconApplyClasses = classnames({
        'fa': true,
        'fa-chevron-up': false,
        'fa-chevron-down': true,
        'fa-2x': true
      })

      iconBFWClasses = classnames({
        'fa': true,
        'fa-chevron-up': false,
        'fa-chevron-down': true,
        'fa-2x': true
      })

      iconFestivalClasses = classnames({
        'fa': true,
        'fa-chevron-up': false,
        'fa-chevron-down': true,
        'fa-2x': true
      })
    }


    let logoBox = (
      <div className="logoBox">
          <Logo />
          <span onClick={this.toggle} className={menuClasses}>
            <i className={iconClasses}></i>
          </span>
      </div>
    )
    if (browser.greaterThan.desktop) {
      logoBox = ''
    }




    let topMenuItemsList = '';
    let topMenuItems = '';
    let topMenuItemLink = '';


    if (this.state.isOpen || browser.greaterThan.desktop) {
      const topMenuItems = this.topMenuObjArray.map(topMenuItem => {


        // Test for BFW so we can add TM
        /*
        if (topMenuItem.slug == 'buy-from-women-owned-businesses') {
          return <li onClick={this.close} className="mainMenu-bfw" key={topMenuItem.slug}>

            <Link  to={`${topMenuItem.url}`}>{topMenuItem.name}&trade;</Link>

          </li>
        }
        */

        if (topMenuItem.hover) {  // Test for drop down elems
          if (topMenuItem.slug == 'categories') { // Add down/up caret
            return <li onClick={this.toggleCategories} className="mainMenu-category" key={topMenuItem.slug}>

              <Link className={menuCategoryClasses}  to={`${topMenuItem.url}`}>{topMenuItem.name} <i className={iconCategoryClasses}></i></Link>

              <div className="mainMenuDropDownWrapper menuCategories">


                <MenuDirectory
                  rootCategories={items}
                  menuCategoryClasses={this.menuCategoryClasses}
                  iconCategoryClasses={this.iconCategoryClasses}
                  categoriesMenuState = {this.state.categoriesOpen}
                  parentCloseFuncCall = {this.closeMenu}
                  browser = {this.props.browser}
                  menuState = {this.state.categoriesOpen}
                />

              </div>

            </li>
          } else if (topMenuItem.slug == 'apply-to-list') { // Add down/up caret

            return <li onClick={this.toggleApply} className="mainMenu-apply" key={topMenuItem.slug}>

              <Link className={menuApplyClasses}  to={`${topMenuItem.url}`}>{topMenuItem.name} <i className={iconApplyClasses}></i></Link>

              <div className="mainMenuDropDownWrapper menuApply">

                <MenuApply
                  applyMenuState = {this.state.applyOpen}
                  parentCloseFuncCall = {this.closeMenu}
                  browser = {this.props.browser}
                />

              </div>

            </li>

          } else if (topMenuItem.slug == 'girls-festival') { // Add down/up caret

            return <li onClick={this.toggleFestival} className="mainMenu-festival" key={topMenuItem.slug}>

              <Link className={menuFestivalClasses}  to={`${topMenuItem.url}`}>{topMenuItem.name} <i className={iconFestivalClasses}></i></Link>

              <div className="mainMenuDropDownWrapper menuFestival">

                <MenuFestival
                  festivalMenuState = {this.state.festivalOpen}
                  parentCloseFuncCall = {this.closeMenu}
                  browser = {this.props.browser}
                />

              </div>

            </li>
          } else if (topMenuItem.slug == 'about-us') { // Add down/up caret

            return <li onClick={this.toggleAbout} className="mainMenu-about" key={topMenuItem.slug}>

              <Link className={menuAboutClasses}  to={`${topMenuItem.url}`}>{topMenuItem.name} <i className={iconAboutClasses}></i></Link>

              <div className="mainMenuDropDownWrapper menuAbout">

                <MenuAbout
                  aboutMenuState = {this.state.aboutOpen}
                  parentCloseFuncCall = {this.closeMenu}
                  browser = {this.props.browser}
                />

              </div>

            </li>
          } else if (topMenuItem.slug == 'buy-from-women-owned-businesses') { // Add down/up caret

            return <li onClick={this.toggleBFW} className="mainMenu-bfw" key={topMenuItem.slug}>

              <Link className={menuBFWClasses}  to={`${topMenuItem.url}`}>{topMenuItem.name} <i className={iconBFWClasses}></i></Link>

              <div className="mainMenuDropDownWrapper menuBFW">

                <MenuBFW
                  bfwMenuState = {this.state.bfwOpen}
                  parentCloseFuncCall = {this.closeMenu}
                  browser = {this.props.browser}
                />

              </div>

            </li>
          } else {
            return <li onClick={this.toggleCategories} className="mainMenu-category" key={topMenuItem.slug}>

              <Link  to={`${topMenuItem.url}`}>{topMenuItem.name}</Link>
              <div className="mainMenuDropDownWrapper menuCategories">

                <div className="mainMenuDropDownWrapper">

                  <MenuCategories
                    rootCategories={items}
                    categoriesMenuState = {this.state.categoriesOpen}
                    parentCloseFuncCall = {this.closeMenu}
                    browser = {this.props.browser}
                  />

                </div>

                <div className="mainMenuDropDownWrapper menuAbout">

                  <MenuApply
                    applyMenuState = {this.state.categoriesOpen}
                    parentCloseFuncCall = {this.closeMenu}
                    browser = {this.props.browser}
                  />

                </div>

                <div className="mainMenuDropDownWrapper menuAbout">

                  <MenuAbout
                    aboutMenuState = {this.state.categoriesOpen}
                    parentCloseFuncCall = {this.closeMenu}
                    browser = {this.props.browser}
                  />

                </div>

                <div className="mainMenuDropDownWrapper menuAbout">

                  <MenuFestival
                    festivalMenuState = {this.state.categoriesOpen}
                    parentCloseFuncCall = {this.closeMenu}
                    browser = {this.props.browser}
                  />

                </div>

              </div>
            </li>
          }



        } else {
          if (topMenuItem.isExternalUrl) {
            topMenuItemLink = <a target="_blank" href={`${topMenuItem.url}`}>{topMenuItem.name}</a>
          } else {
            topMenuItemLink = <Link to={`${topMenuItem.url}`}>{topMenuItem.name}</Link>
          }
          return <li onClick={this.toggle} key={topMenuItem.slug}>
            {topMenuItemLink}
          </li>
        }

      });

      topMenuItemsList = <ul>{topMenuItems}</ul>
    }


    return (
      <nav>

        { logoBox }
        { topMenuItemsList }

      </nav>
    )
  }

}

MenuMain.propTypes = {
  items: PropTypes.array
}

export { Logo, MenuMain}



// WEBPACK FOOTER //
// ./src/components/header/MenuMain.jsx